export const imageExtensions = ["png", "jpg", "jpeg"];
export const imageMaxSizeInBytes = 2 * 1024 * 1024;
export const companyImageMaxSizeInBytes = 5 * 1024 * 100;
export const paymentImageMaxSizeInBytes = 3 * 1024 * 100;
export const flashDealImageMaxSizeInBytes = 8 * 1024 * 100;
export const trendingImageMaxSizeInBytes = 5 * 1024 * 100;
export const whyBdticketsImageMaxSizeInBytes = 7 * 1024 * 100;
export const mobileBannerImageMaxSizeInBytes = 5 * 1024 * 100;
export const webBannerImageMaxSizeInBytes = 10 * 1024 * 100;
export const agentNidTradeImageMaxSizeInBytes = 10 * 1024 * 100;

export const imageConstraints = {
    shortcut: {
        extensions: imageExtensions,
        width: 32,
        height: 32,
        allowRatio: true,
        allowCompression: true,
        restrictType: false,
        max_file_size: imageMaxSizeInBytes,
    },
    web_banner_images: {
        extensions: imageExtensions,
        width: 1440,
        height: 648,
        allowRatio: true,
        allowCompression: true,
        restrictType: false,
    },
    mobile_banner_image: {
        extensions: imageExtensions,
        width: 360,
        height: 192,
        allowRatio: true,
        allowCompression: true,
        restrictType: false,
    },
    why_bdtickets: {
        extensions: imageExtensions,
        width: 292,
        height: 143,
        allowRatio: true,
        allowCompression: true,
        restrictType: false,
    },
    trending: {
        extensions: imageExtensions,
        width: 176,
        height: 176,
        allowRatio: true,
        allowCompression: true,
        restrictType: false,
    },
    flash_deal: {
        extensions: imageExtensions,
        width: 128,
        height: 128,
        allowRatio: true,
        allowCompression: true,
        restrictType: false,
    },
    company_logo: {
        extensions: imageExtensions,
        width: 90,
        height: 64,
        allowRatio: true,
        allowCompression: true,
        restrictType: false,
    },
    payment_method: {
        extensions: imageExtensions,
        width: 60,
        height: 52,
        allowRatio: true,
        allowCompression: true,
        restrictType: false,
    },
    agent_nid_trade: {
        extensions: imageExtensions,
        width: 2000,
        height: 5000,
        allowRatio: true,
        allowCompression: true,
        restrictType: false,
    },
    faq_category:{
        extensions: ['png'],
        width: 24,
        height: 24,
        allowRatio: false,
        allowCompression: false,
        restrictType: true,
    }
};
